import is from 'is_js';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
    components: { FontAwesomeIcon },
    props: {
        hasMenu: { type: Boolean, default: false },
    },
    data() {
        return {
            is: is,
            model: window.matchMedia('(display-mode: standalone)').matches,
        };
    },
    methods: {
        onClick() { this.model = !this.model; }
    },
    created() {}
}
